import React, { createContext, useState } from "react";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(localStorage.getItem("access_token"));
  const [subscriped, setSubscriped] = useState(false);

  return (
    <UserContext.Provider value={{ user, setUser, subscriped, setSubscriped }}>
      {children}
    </UserContext.Provider>
  );
};
